<template>
  <div>
    <b-input-file
      v-if="!documentSource.document && !disabled"
      v-model="documentCredentials.document"
      :show-files="false"
      :name-folder="String(documentId)"
      main-folder="Документы"
      :multiple="false"
      dropper
      @update:model-value="updateDocumentFile">
      <template #dropper>
        <v-hover v-slot="{ isHovering, props }">
          <v-card
            v-bind="props"
            style="border: 2px dashed rgb(213, 213, 224); padding: 50px 30px"
            class="text-center cursor-pointer"
            :class="{
              'bg-blue-lighten-5': isHovering,
            }">
            <div class="mb-3">
              <v-icon
                color="grey-lighten-2"
                icon="mdi-upload-box-outline"
                style="font-size: 60px"></v-icon>
            </div>
            <div class="font-size-18 font-weight-bold mb-2">
              Завантажте документ
            </div>
            <div class="text-disabled mb-3">
              <div>Перетягніть файл сюди або натисніть для вибору.</div>
              <div>Підтримувані формати: PDF, DOCX, XLSX, ODT</div>
            </div>
            <v-btn color="light-blue-darken-4 mb-3">
              <v-icon icon="mdi-tray-arrow-up" class="mr-2"></v-icon>
              <span>Обрати файл</span>
            </v-btn>
            <div class="text-disabled">Максимальний розмір: 15 МБ</div>
          </v-card>
        </v-hover>
      </template>
    </b-input-file>
    <document-preview
      v-else
      id="document-preview"
      :key="documentPreviewHeight"
      :style="{ height: documentPreviewHeight }"
      :document="documentSource.document"></document-preview>
  </div>
</template>

<script setup lang="ts">
import { useDocument } from '@/pages/document/single/document'
import { nextTick, ref, watch } from 'vue'
import { BInputFile } from 'best-modules/components'
import DocumentPreview from '@/components/document-page-template/DocumentPreview.vue'

defineOptions({
  name: 'Preview',
})
const {
  documentId,
  documentSource,
  documentCredentials,
  updateDocumentFile,
  disabled,
} = useDocument()

const documentPreviewHeight = ref<string>('100%')
const setDocumentPreviewHeight = () => {
  if (!document) return

  nextTick(() => {
    const documentPreviewElement = document.getElementById('document-preview')!
    if (documentPreviewElement && documentSource.document) {
      console.dir(documentPreviewElement)
      console.dir(documentPreviewElement?.offsetTop)

      if (documentPreviewElement) {
        documentPreviewHeight.value = `calc(100vh - ${
          documentPreviewElement.getBoundingClientRect().top
        }px - 28px)`
        // documentPreviewHeight.value =
        //   documentPreviewElement.clientWidth * 1.41 + 'px'
      }
    }
  })
}
watch(() => documentSource.document, setDocumentPreviewHeight, {
  immediate: true,
})
</script>
